/**
 * documentation at
 * https://webartelier.de/fee_doc/list_classes.html#lazyload
 */


class Lazyload {

  static init = (params) => {
    const selRoot = `${params.selRoot}:not(.has-lazyload)`;
    const allRoots = document.querySelectorAll(selRoot);

    allRoots.forEach(root => {
      new Lazyload(root, params);
    })
  }



  constructor(root, params) {
    this.root = root;
    this.selBox = params.selBox
    this.selImage = params.selImage

    this.markInitialized();
    this.findAlreadyLoadedImages();
    this.startListening();
  }



  findAlreadyLoadedImages = () => {
    const allBoxes = this.root.querySelectorAll(this.selBox);

    allBoxes.forEach(box => {
      const image = box.querySelector(this.selImage);
      if (!image) this.handleMissingImage();
      if (image && image.complete) this.markLoaded(image);
    })
  }



  startListening = () => {
    this.root.addEventListener('load', (e) => {
      if (e.target.matches(this.selImage)) {
        this.markLoaded(e.target);
      }
    }, true);
  }



  markInitialized = () => {
    this.root.classList.add('has-lazyload');
  }



  markLoaded = (image) => {
    image.classList.add('is-loaded');
  }



  handleMissingImage = () => {
    console.warn('Missing image inside lazyload box!');
  }
}